/* unplugin-vue-components disabled */import script from "./postReleaseManager.vue?vue&type=script&setup=true&lang=ts"
export * from "./postReleaseManager.vue?vue&type=script&setup=true&lang=ts"

import "./postReleaseManager.vue?vue&type=style&index=0&id=8e265866&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8e265866"]])

export default __exports__